import DefaultSidebar from '@components/sidebars/default.sidebar'
import useUserNavigationMenu from '@hooks/menus/use-user-navigation-menu.hook'

export default function UserSidebar() {
    const { navigation } = useUserNavigationMenu()

    return (
        <DefaultSidebar navigation={navigation} />
    )
}